import PageHero from "@/components/PageHero";
import ServiceAccordion from "@/components/ServiceAccordion";
import CtaBand from "@/components/CtaBand";
import { Reveal } from "@/components/motion";
import { usePageMeta } from "@/lib/api";

export default function ServicesPage() {
  usePageMeta(
    "ESG & Sustainability Consulting Services | SarvaRitam — ESG Strategy, BRSR, Climate & Carbon",
    "SarvaRitam's ESG & sustainability services: ESG strategy and materiality, climate and carbon (GHG accounting, climate risk, net zero), BRSR and sustainability reporting, ESG policies and governance, biodiversity and social, responsible investment and training."
  );
  return (
    <>
      <PageHero
        eyebrow="What we do"
        title={[<>ESG & Sustainability expertise. <span className="text-gold">Practical outcomes.</span></>]}
        intro="Six practices, one method: measure what matters, understand it honestly, and turn it into decisions. Select a category to see the services inside."
      />
      <section className="bg-ink text-white sec border-t rule-dark">
        <div className="wrap">
          <ServiceAccordion />
        </div>
      </section>
      <section className="bg-white text-ink sec">
        <div className="wrap max-w-3xl">
          <Reveal>
            <p className="eyebrow text-gold mb-5">How engagements start</p>
            <p className="text-ink/70 text-[15.5px] sm:text-lg leading-[1.85]">
              Most engagements begin with a short conversation and, where useful, the ESG Readiness Assessment — so
              effort goes to the areas that matter first. Everything above can be delivered standalone or as part of
              an integrated programme.
            </p>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
